import React, { createContext, useReducer, useMemo } from "react";

let CertificadosContext = createContext();

let initialState = {
    openCargarCertificado: false,
    archivoBase64: null,
    claveCertificado: ""
};

let fixedState = JSON.parse(JSON.stringify(initialState));

let reducer = (state, action) => {
    switch (action.type) {
        case "reset": {
            return fixedState;
        }
        case "toggleCargarCertificado": {
            return { ...state, openCargarCertificado: !state.openCargarCertificado };
        }
        case "loadCertificado": {
            return { ...state, archivoBase64: action.archivoBase64 };
        }
        case "changeClaveCertificado": {
            return { ...state, claveCertificado: action.claveCertificado };
        }
        default:
            return state;
    }
};

function CertificadosProvider(props) {
    let [state, dispatch] = useReducer(reducer, initialState);
    let value = useMemo(() => ({ state, dispatch }), [state]);

    return (
        <CertificadosContext.Provider value={value}>{props.children}</CertificadosContext.Provider>
    );
}

let CertificadosConsumer = CertificadosContext.Consumer;

export { CertificadosContext as CertificadosContext, CertificadosProvider as CertificadosProvider, CertificadosConsumer as CertificadosConsumer };